module.exports = __webpack_public_path__ + "static/media/WB 2 Student 2.9db482a7.svg";